module.exports = __webpack_public_path__ + "img/hzm-back.09ba1ec7.png";